import React, { Component } from "react";
import {
    Select
} from "@shopify/polaris";
import {  } from "@shopify/polaris-icons";
import "./index.css";

import Language from '../../i18n/Language';
const t = Language

class FooterPageSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lessoptions: [
        {label: 5, value: 5},
        {label: 10, value: 10},
        {label: 30, value: 30},
        {label: 50, value: 50},
        {label: 70, value: 70},
        {label: 100, value: 100},
      ],
      options: [
        {label: 10, value: 10},
        {label: 30, value: 30},
        {label: 50, value: 50},
        {label: 70, value: 70},
        {label: 100, value: 100},
      ],
      current_PageSize: props.current_PageSize,
      startNum: props.startNum,
      endNum: props.endNum,
      total: props.total,
      isLess: props.isLess, // true代表是默认5条
      isShort: props.isShort,
      tableLoading: props.tableLoading, // 表格loading
      isCustomizeType: this.props.isCustomizeType,
    };
  }

  componentDidMount() {

  }

  shouldComponentUpdate(nextProps) {
    if(nextProps.startNum !== this.props.startNum) {
      this.setState({
          startNum: nextProps.startNum,
          endNum: nextProps.endNum,
          total: nextProps.total,
      })
    }
    if(nextProps.endNum !== this.props.endNum) {
        this.setState({
            startNum: nextProps.startNum,
            endNum: nextProps.endNum,
            total: nextProps.total,
            current_PageSize: nextProps.current_PageSize
        })
    }
    if(nextProps.total !== this.props.total) {
      this.setState({
          total: nextProps.total,
      })
    }

    if(nextProps.isLess !== this.props.isLess) {
        this.setState({
            isLess: nextProps.isLess,
        })
    }

    if(nextProps.current_PageSize !== this.props.current_PageSize) {
      this.setState({
          current_PageSize: nextProps.current_PageSize,
      })
    }

    if(nextProps.isShort !== this.props.isShort) {
      this.setState({
          isShort: nextProps.isShort,
      })
    }

    if(nextProps.isCustomizeType !== this.props.isCustomizeType) {
      this.setState({
          isCustomizeType: nextProps.isCustomizeType,
      })
    }

    return true;
  }

  // 选择条数
  handleSelectChange = (e) => {
    this.props.changePageSize(e);
  }

  render() {
    const {
        state: {
            lessoptions,
            options,
            current_PageSize,
            startNum,
            endNum,
            total,
            isLess,
            isShort,
            tableLoading,
            isCustomizeType,
        },
        handleSelectChange
    } = this;
    const footer_text_front = 
    Boolean(isCustomizeType) ? (
      isCustomizeType === 'product' ? t("Showing {{v1}} - {{v2}} of {{v3}} products, at most", startNum, endNum, total) : 
      isCustomizeType === 'collection' ? t("Showing {{v1}} - {{v2}} of {{v3}} collections, at most", startNum, endNum, total) : 
      isCustomizeType === 'blog' ? t("Showing {{v1}} - {{v2}} of {{v3}} blogs, at most", startNum, endNum, total) : null
    ) : !Boolean(isShort) ? t("Showing {{v1}} - {{v2}} of {{v3}} results, at most", startNum, endNum, total) : 
      t("Showing {{v1}} - {{v2}} of {{v3}} results, ", startNum, endNum, total);
    const footer_text_back = !Boolean(isShort) ? t("per page") : '';

    return (
      <div className="FooterPageSelect">
        <span>{footer_text_front}</span>
        <div className="select-footerbox">
            <Select
                options={isLess ? lessoptions : options}
                onChange={handleSelectChange}
                value={Number(current_PageSize)}
                disabled={tableLoading}
            />
        </div>
        <span>{footer_text_back}</span>
      </div>
    );
  }
}

export default FooterPageSelect;
